"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftToken = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var GetNftToken = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetNftToken, _super);
    function GetNftToken() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取nft登录token';
        _this.code = '300009';
        _this.desc = '获取nft登录token';
        _this.requestParams = new guMember_1.RegistOrLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetNftToken;
}(service_1.BaseService));
exports.GetNftToken = GetNftToken;
//# sourceMappingURL=getNftToken.js.map